import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BannerCalloutComponent } from './banner-callout.component'
import { SvgModule } from '../../shared/svg/svg.module'

@NgModule({
  imports: [CommonModule, SvgModule],
  declarations: [BannerCalloutComponent],
  exports: [BannerCalloutComponent]
})
export class BannerCalloutModule {}
